/**
 * Reusable address grid — address line + city/state/country/pincode.
 * `prefix` lets us reuse this for "student address" or "parent_*" fields.
 *
 * `requireRequired` makes the four primary fields (address line, city, state, pincode)
 * required at form-submit time. Country is auto-defaulted to India so it's always set.
 */
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function AddressSection({ form, set, prefix = "", testIdPrefix = "adm", requireRequired = false }) {
  const k = (key) => (prefix ? `${prefix}_${key}` : key);
  const numeric = (e) => e.target.value.replace(/[^\d]/g, "");
  const mark = requireRequired ? " *" : "";
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="md:col-span-3">
        <Label>{prefix ? "Parent address" : "Address line"}{mark}</Label>
        <Textarea
          data-testid={`${testIdPrefix}-${prefix ? "parent-" : ""}address`}
          required={requireRequired}
          value={form[k("address")] || ""}
          onChange={(e) => set(k("address"), e.target.value)}
          rows={2}
          className="bg-white"
        />
      </div>
      <div>
        <Label>{prefix ? "Parent city" : "City"}{mark}</Label>
        <Input data-testid={`${testIdPrefix}-${prefix ? "parent-" : ""}city`} required={requireRequired} value={form[k("city")] || ""} onChange={(e) => set(k("city"), e.target.value)} className="bg-white" />
      </div>
      <div>
        <Label>{prefix ? "Parent state" : "State"}{mark}</Label>
        <Input data-testid={`${testIdPrefix}-${prefix ? "parent-" : ""}state`} required={requireRequired} value={form[k("state")] || ""} onChange={(e) => set(k("state"), e.target.value)} className="bg-white" />
      </div>
      <div>
        <Label>{prefix ? "Parent country" : "Country"}</Label>
        <Input data-testid={`${testIdPrefix}-${prefix ? "parent-" : ""}country`} value={form[k("country")] || "India"} onChange={(e) => set(k("country"), e.target.value)} className="bg-white" />
      </div>
      <div>
        <Label>{prefix ? "Parent pincode" : "Pincode"}{mark}</Label>
        <Input data-testid={`${testIdPrefix}-${prefix ? "parent-" : ""}pincode`} required={requireRequired} inputMode="numeric" pattern="[0-9]{4,6}" value={form[k("pincode")] || ""} onChange={(e) => set(k("pincode"), numeric(e))} className="bg-white font-mono" />
      </div>
    </div>
  );
}
